import { SuperInputBase } from "@components:SuperInput/SuperInput.Base";
import { SuperInputProps } from "@components:SuperInput/types";
import { Select, SelectProps } from "@mui/material";

export type SuperInputSelectProps = SuperInputProps &
  SelectProps & {
    width?: string;
  };

export const SuperInputSelect = ({
  label,
  helperText,
  explainText,
  sx,
  width,
  errorText,
  required,
  autoHeight,
  ...props
}: SuperInputSelectProps) => {
  return (
    <SuperInputBase
      label={label}
      helperText={helperText}
      explainText={explainText}
      errorText={errorText}
      sx={sx}
      required={required}
      autoHeight={autoHeight}
    >
      <Select
        {...props}
        className={"SuperInput__Select with-bg"}
        sx={{
          width: width ?? undefined,
        }}
      />
    </SuperInputBase>
  );
};
